import { useCallback } from 'react';
import { User } from 'types/UserTypes';
import { UserListHead } from '../../../../../sections/@dashboard/user';
import { tableSx, TABLE_HEAD, tableCellSx } from './constants';
import { TableContentProps } from './interface';
import { Table, TableRow, TableBody as Body, TableCell, TableContainer } from '@mui/material';
import Scrollbar from 'components/atoms/Scrollbar';
import SearchNotFound from 'components/atoms/SearchNotFound';
import { TableBody } from './components';

export default function TableContent(props: TableContentProps) {
  const {
    users,
    isOrderReversed,
    orderBy,
    searchName,
    selectedUsers,
    setIsOrderReversed,
    setOrderBy,
    setSelectedUsers,
  } = props;

  const handleRequestSort = useCallback(
    (event: React.MouseEvent<HTMLAnchorElement>, property: string) => {
      const isAsc = orderBy === property && !isOrderReversed;
      setIsOrderReversed(isAsc);
      setOrderBy(property as keyof User);
    },
    [isOrderReversed, orderBy, setIsOrderReversed, setOrderBy],
  );

  const handleSelectAllClick = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      if (event.target.checked) {
        setSelectedUsers(users);
        return;
      }
      setSelectedUsers([]);
    },
    [users, setSelectedUsers],
  );
  const isUserNotFound = users.length === 0;

  return (
    <TableContainer sx={tableSx}>
      <Table>
        <UserListHead
          order={isOrderReversed ? 'desc' : 'asc'}
          orderBy={orderBy}
          headLabel={TABLE_HEAD}
          rowCount={users.length}
          numSelected={selectedUsers.length}
          onRequestSort={handleRequestSort}
          onSelectAllClick={handleSelectAllClick}
        />
        <TableBody
          selectedUsers={selectedUsers}
          users={users}
          setSelectedUsers={setSelectedUsers}
        />
        {isUserNotFound && (
          <Body>
            <TableRow>
              <TableCell align="center" colSpan={6} sx={tableCellSx}>
                <SearchNotFound searchQuery={searchName} />
              </TableCell>
            </TableRow>
          </Body>
        )}
      </Table>
    </TableContainer>
  );
}
